import type React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Link } from "@mui/material"
import { useUser } from "@/contexts/UserContext"

interface WelcomeDialogProps {
  open: boolean
  onClose: () => void
}

const WelcomeDialog: React.FC<WelcomeDialogProps> = ({ open, onClose }) => {
  const { user } = useUser()
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
          Welcome to Pythaverse and the Indonesia National Robothon Competition 2025 – 1st Stage!
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography paragraph>
            We're excited to have you join our community and participate in the upcoming competition! Whether you're a
            robotics enthusiast, a seasoned competitor, or just starting your journey, this is your chance to showcase
            your skills, innovate, and collaborate with some of the brightest minds in the field. Let's make this
            competition an unforgettable experience!
          </Typography>
        </Box>

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          🔥 How to Prepare for the Challenge:
        </Typography>

        <Box component="ul" sx={{ p: 0 }}>
          <Box sx={{ mb: 2 }}>
            <Typography>
              <span role="img" aria-label="checkmark">
                ✅
              </span>{" "}
              <Link href={process.env.URL_INDO_CONTEST + '?required=login'} target="_blank" color="primary">
                Register Now!
              </Link>{" "}
              Secure your spot and take the first step toward victory!
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography>
              <span role="img" aria-label="checkmark">
                ✅
              </span>{" "}
              <Link
                href={process.env.URL_INDO_CONTEST_RULES}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="primary"
              >
                Know the Rules & Schedule
              </Link>
              : Stay ahead by reviewing competition guidelines and key dates - don't miss out on any important rounds or
              the grand awards ceremony!
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography paragraph>
            Join the courses to enhance your knowledge and skills to ready for the competition!
          </Typography>
          <Typography paragraph>
            <Link
              href={process.env.URL_COURSE_AI_CODING}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary"
            >
              - AI & Coding Kickoff (Basic Level) 
            </Link>
          </Typography>
          <Typography paragraph>
            <Link
              href={process.env.URL_COURSE_AI_BLOCKLY_CODING}
              // target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary"
            >
              - Pythaverse Advanced AI & Blockly Coding Workshop
            </Link>
          </Typography>
          <Typography paragraph>
            Gear up, bring your best ideas, and get ready to compete at the highest level!
          </Typography>
          <Typography paragraph>
            See you at the Robothon!{" "}
            <span role="img" aria-label="robot">
              🤖
            </span>
            <span role="img" aria-label="lightbulb">
              💡
            </span>
          </Typography>
          <Typography>— The Pythaverse Team</Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default WelcomeDialog

